/*global VeloxViewController, VeloxWebView*/
var uuid = require("uuid") ;

var helpmeController = new VeloxViewController({
    directory: "views/main",
    name: "helpme",
    route: "helpme",
    openInPopup: true,
    popup: {
        size: "large"
    },
});


helpmeController.onSend = function(){
    this.view.checkForm(function(err, checkOk){
        if(err){ return this.view.error(err) ;}
        if(checkOk){
            this.view.longTask(function(done){
                var emailDest = "help.me@bayrolsolution.com";
                var lang = VeloxWebView.i18n.getLang() ;
                if(lang === "fr-FR"){
                    emailDest = "help.me@bayrolsolution.com";
                }else if(lang === "de-DE") {
                    emailDest = "cnoichl@bayrol.eu";
                }else if(lang === "en-US") {
                    emailDest = "help.me@bayrolsolution.com";
                }else if(lang === "es-ES") {
                    emailDest = "gverlet@bayrol.eu";
                }
                var from = "noreply@bayrolsolution.com";
                var subject = VeloxWebView.tr("helpme.subjectMail") ;

                var customer = this.view.getData() ;

                var text = VeloxWebView.tr("helpme.bodyMail",
                    {
                        company : customer.c_name,
                        contact : customer.c_first_name,
                        email   : customer.c_email,
                        phone   : customer.c_phone_home,
                        address : customer.c_address1,
                        zip     : customer.c_zipcode,
                        city    : customer.c_city,
                        msg     : customer.c_notes
                    }
                ) ;
                var htmlMail = text.replace(/\n/g, "<br />") ;

                var emailRecord = {
                    uid: uuid.v4(),
                    server_uid: "noreply", 
                    from_addr: from,
                    to_addr: emailDest,
                    subject: subject,
                    text: text,
                    html: htmlMail,
                    status: "tosend",
                    schedule_type: "now",
                };
                this.api.api.transactionalChanges([{table: "velox_mail", record: emailRecord}], function(err){
                    if(err){ return done(err) ;}
                    done() ;
                    VeloxWebView.info(VeloxWebView.tr("helpme.confirmSent"), function(){
                        this.view.close() ;
                    }.bind(this)) ;
                }.bind(this)) ;
            }.bind(this)) ;
        }
    }.bind(this)) ;
} ;

module.exports = helpmeController ;